import {Component, Inject, inject, signal} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from "@angular/material/dialog";
import {Subject} from "rxjs";
import {Router} from "@angular/router";
import {DialogTextModel} from "../../../core/cms/models/dialog.text.model";
import {DialogRestService} from "../../../core/cms/services/dialog.rest.service";
import {finalize, take, takeUntil} from "rxjs/operators";
import {LogService} from "../../../core/base/log.service";

@Component({
  selector: 'app-requalification',
  imports: [
    MatButton,
    MatDialogActions
  ],
  standalone: true,
  templateUrl: './requalification.component.html',
  styleUrls: ['./requalification.component.scss']
})
export class RequalificationComponent {
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  private readonly log = inject(LogService);
  readonly saving = signal(false);
  readonly error = signal<string | null>(null);

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogTextModel,
              private dialogRestService: DialogRestService,
              public dialogRef: MatDialogRef<RequalificationComponent>,
              private router: Router) {
  }

  onLinkClick() {
    if (this.saving()) return;
    if (!this.data.subscription) {
      this.navigateToLink();
      this.dialogRef.close();
      return;
    }

    this.saving.set(true);
    this.error.set(null);
    this.dialogRestService.subscribeToDialogOffer(this.data.id, this.data.idf).pipe(
      take(1),
      takeUntil(this.ngUnsubscribe$),
      finalize(() => this.saving.set(false))
    ).subscribe({
      next: res => {
        if (res.error_code !== null) {
          this.error.set('Die Bestätigung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.');
          this.log.error('Unable to confirm requalification popup', res.error_code);
          return;
        }
        this.navigateToLink();
        this.dialogRef.close();
      },
      error: error => {
        this.error.set('Die Bestätigung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.');
        this.log.error('Unable to confirm requalification popup', error);
      }
    });
  }

  private navigateToLink(): void {
    if (this.data.link == null) {
      return;
    }

    if (this.data.target === '_blank') {
      window.open(this.data.link, '_blank');
    } else if (this.data.link.startsWith('/')) {
      this.router.navigateByUrl(this.data.link);
    } else {
      window.location.assign(this.data.link);
    }
  }

  ngOnDestroy(): void {
    // This aborts all HTTP requests.
    this.ngUnsubscribe$.next();
    // This completes the subject properly.
    this.ngUnsubscribe$.complete();
  }
}
